import React, { Component, Fragment } from 'react'
import { ChangeHistoryDetailModel } from './models/change.history.detail.model'
import { ChangeHistoryService } from './services/change.history.service';
import { HttpResponse } from '../../../../core';
import { NavLink } from "react-router-dom";
import { ConvertDateTime, HandleNotFoundResponse } from '../../../../shared/helpers';
import { Editor } from '../../../../shared';
import { DashboardChangeHistoryTabs } from './DashboardChangeHistoryTabs'
import { NotFoundResponseArea } from '../../../../shared/enums';
import { Loader } from '../../../../shared/loaders';
import { DashboardChangeHistoryDescription } from './DashboardChangeHistoryDescription';
import { STYLE_LABEL_MAP } from './constants/labels';

interface IState {
    result?: ChangeHistoryDetailModel;
    parsedData?: string;
    isLoading?: boolean;
    descriptionText?: string;
}
export class DashboardChangeHistoryDetail extends Component<any, IState> {
    private service: ChangeHistoryService;
    constructor(props) {
        super(props);
        this.state = this.initialState;
        this.service = new ChangeHistoryService();
    }

    initialState: Partial<IState> = {
        result: {
            description: "",
            created_at: new Date(),
            ip: "",
            object: {},
            object_changes: {},
            id: 0,
            admin_id: 0,
            admin_name: "",
            dashboard_id: 0,
            dashboard_name: "",
            user_id: 0,
            user_name: "",
            whodunnit: "",
            item_id: 0,
            item_type: "",
            event: "",
        },
        parsedData: "",
        isLoading: false,
        descriptionText: "",
    }

    componentDidMount() {
        this.loadData();
    }

    private setLoading(loading: boolean) {
        this.setState({ isLoading: loading });
    }

    formatParsedSettings(settings: any) {
    if (!settings || typeof settings !== "object") return settings;

    const STYLE_CONTAINER_KEYS = ["settings", "shared_settings", "custom_settings"];

    const formatted = { ...settings };

    STYLE_CONTAINER_KEYS.forEach((key) => {
        const container = formatted[key];
        const style = container?.[":style"];

        if (style && STYLE_LABEL_MAP[style]) {
        formatted[key] = {
            ...container,
            ":style": STYLE_LABEL_MAP[style],
        };
        }
    });

    return formatted;
    }

    loadData() {
        this.setLoading(true);
        this.service.getChangeHistoryById(this.props.match.params.id)
            .then((res: HttpResponse<ChangeHistoryDetailModel>) => {
                if (res?.result) {
                    const result = res.result;

                    // build parsed object in one go
                    const object = {
                        ...(result.object),
                        ...(result.parsed_object_settings && { settings: result.parsed_object_settings }),
                        ...(result.parsed_object_shared_settings && { shared_settings: result.parsed_object_shared_settings }),
                        ...(result.parsed_object_custom_settings && { custom_settings: result.parsed_object_custom_settings }),
                    };

                    this.setState({
                        result,
                        parsedData: JSON.stringify(this.formatParsedSettings(object), null, '\t'),
                        isLoading: false,
                    });
                } else {
                    this.setLoading(false);
                }
            })
            .catch(ex => {
                this.setLoading(false);
                HandleNotFoundResponse(ex, NotFoundResponseArea.DashboardChangeHistories, this.props);
            });
    }
    render() {
        return (
            <Fragment>
                <div>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h4>Details for Dashboard Change History '{ConvertDateTime(this.state.result?.created_at, 'LLL')}'</h4>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body">
                                    <DashboardChangeHistoryTabs id={this.props.match.params.id} url="/dashboard-change-history/detail/" />
                                    {!this.state.isLoading && <>
                                        <h5 className="mb-3">Basic Info</h5>
                                        <div className="row">
                                            <div className="col">
                                                <div className="card card-silver shadow-sm">
                                                    <div className="card-header font-weight-bold"> Dashboard </div>
                                                    <div className="card-body"><NavLink to={"/dashboard/detail/" + this.state.result?.dashboard_id}>{this.state.result?.dashboard_name}</NavLink></div>
                                                </div>
                                            </div>
                                            <div className="col">
                                                <div className="card card-silver shadow-sm">
                                                    <div className="card-header font-weight-bold"> Edited By </div>
                                                    <div className="card-body"><NavLink to={"/user/detail/" + this.state.result?.user_id}>{this.state.result?.user_name}</NavLink></div>
                                                </div>
                                            </div>
                                            <div className="col">
                                                <div className="card card-silver shadow-sm">
                                                    <div className="card-header font-weight-bold"> Edited At </div>
                                                    <div className="card-body">{ConvertDateTime(this.state.result?.created_at, 'LLL')}</div>
                                                </div>
                                            </div>
                                            <div className="col">
                                                <div className="card card-silver shadow-sm">
                                                    <div className="card-header font-weight-bold"> Ip </div>
                                                    <div className="card-body">{this.state.result?.ip}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            {this.state.result && <div className="col-md-6  mt-3">
                                                <h6>Description</h6>
                                                <DashboardChangeHistoryDescription result={this.state.result} />
                                            </div>}
                                            {this.props.match.params.id && this.state.result?.object != null && this.state.result?.object && <div className="col-md-6  mt-3">
                                                <h6>Dashboard Definition Before Changes</h6>
                                                <Editor StringData={this.state.parsedData} FormateType="json" />
                                            </div>}
                                        </div>
                                    </>}
                                    {this.state.isLoading && <Loader loading={this.state.isLoading} />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}